import { render, staticRenderFns } from "./HomeFeaturesSwap.vue?vue&type=template&id=7d3acfef&scoped=true"
import script from "./HomeFeaturesSwap.vue?vue&type=script&lang=js"
export * from "./HomeFeaturesSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3acfef",
  null
  
)

export default component.exports